import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Icon } from '@ln/common-ui-icon';
import { ExclusiveLn, Padlock } from '@ln/adquisicion-ui-assets';
import { Text } from '@ln/common-ui-text';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function AvatarBadge(_a) {
    var { children, className, suscriber } = _a, r = __rest(_a, ["children", "className", "suscriber"]);
    const _className = classNames('-bottom-8 bg-neutral-light-1 flex jc-center ai-center gap-4 pt-4 pr-8 pb-4 pl-4', className);
    return (jsxs("div", Object.assign({ className: _className }, r, { children: [jsx("div", Object.assign({ className: 'flex ai-center p-4 bg-light-400 rounded-100' }, { children: jsx(Icon, Object.assign({ size: 16, hasWrapper: true, bgColor: suscriber ? "#000" : '#f2f2f2' }, { children: suscriber ? jsx(ExclusiveLn, {}) : jsx(Padlock, {}) })) })), jsx(Text, Object.assign({ className: 'roboto-bold text-16' }, { children: children }))] })));
}

function AvatarEmail(_a) {
    var { className } = _a, r = __rest(_a, ["className"]);
    const _className = classNames('text-16 roboto-bold', className);
    return (jsx(Text, Object.assign({ className: _className }, r)));
}

function AvatarUserImage(_a) {
    var { className, variant = 'sinSuscripcion', size = 40 } = _a, r = __rest(_a, ["className", "variant", "size"]);
    const avatarVariantColors = {
        sinSuscripcion: 'bg-neutral-light-200 text-neutral-light-800',
        conSuscripcion: 'bg-neutral-dark-50 text-orange-400',
    };
    const avatarSizes = {
        40: 'w-40 text-12',
        96: 'w-96 text-24',
    };
    const _className = classNames('flex ai-center jc-center rounded-circle roboto-bold ratio-1-1', avatarVariantColors[variant], avatarSizes[size], className);
    return (jsx("div", Object.assign({ className: _className, "data-variant": variant }, r)));
}

function Avatar(_a) {
    var { className } = _a, r = __rest(_a, ["className"]);
    const _className = classNames('flex flex-column gap-16 ai-center', className);
    return (jsx("div", Object.assign({ className: _className }, r)));
}
Avatar.UserImage = AvatarUserImage;
Avatar.Email = AvatarEmail;
Avatar.Badge = AvatarBadge;

export { Avatar };
